import { PerformanceTab } from 'model/FundDetails';
import { useSelector } from 'react-redux';
import { getAvailableTabs } from '@/store/fundDetails';
import AnnualizedTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedTable';
import CumulativeTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeTable';
import AnnualizedDailyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedDailyTable';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import CumulativeDailyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeDailyTable';
import FundDetailsPerformanceDisclaimer from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPerformanceDisclaimer';

const FundDetailsThaiPerformanceTab = ({ title }) => {
  const availablePerformanceTabs: PerformanceTab = useSelector(getAvailableTabs)?.performanceTab;

  const ThaiPerformanceTabContent = () => {
    return (
      <FundDetailsTabRow fullWidth className="mt-8">
        {availablePerformanceTabs.thaiCumulativeDailyTable && <CumulativeDailyTable />}
        {availablePerformanceTabs.thaiAnnualizedDailyTable && <AnnualizedDailyTable />}
        {availablePerformanceTabs.thaiCumulativeTable && <CumulativeTable />}
        {availablePerformanceTabs.thaiAnnualizedTable && <AnnualizedTable />}
      </FundDetailsTabRow>
    );
  };

  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow>
        <h2>{title}</h2>
      </FundDetailsTabRow>

      <ThaiPerformanceTabContent />

      <FundDetailsPerformanceDisclaimer isThai className="mt-8" />
    </section>
  );
};

export default FundDetailsThaiPerformanceTab;
